import { useTranslation } from "react-i18next";
import { CampaignManageRecipientsButton } from "./CampaignManageRecipientsButton.js";
import { CampaignPrelaunchIllustration } from "./CampaignPrelaunchIllustration.js";

export function CampaignEmptyAudienceState({
  canMutate,
  onManageRecipients,
}: {
  canMutate: boolean;
  onManageRecipients: () => void;
}): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <section
      className="grid w-full justify-items-center gap-4 rounded-xl border border-line/70 bg-surface px-4 py-8 text-center"
      data-testid="campaign-empty-audience"
    >
      <CampaignPrelaunchIllustration />
      <div className="grid max-w-md gap-1">
        <h2 className="m-0 text-[1rem] font-semibold tracking-[-0.01em]">
          {t("campaigns.emptyAudience.title")}
        </h2>
        <p className="m-0 text-[0.8125rem] leading-snug text-muted">
          {t("campaigns.emptyAudience.description")}
        </p>
      </div>
      {canMutate ? (
        <CampaignManageRecipientsButton
          testId="campaign-empty-manage-recipients"
          onClick={onManageRecipients}
        />
      ) : null}
    </section>
  );
}
